import type { FC, ReactNode } from 'react'

import { Check, X } from 'lucide-react'
import { useBag } from '@/components/generals/bag-provider'

export const BagToast: FC = (): ReactNode => {
    const { notice, dismissNotice, openBag } = useBag()

    return (
        <div
            aria-live='polite'
            className='pointer-events-none fixed inset-x-0 bottom-4 z-[55] flex justify-center px-4 sm:bottom-6'
        >
            {notice && (
                <div
                    key={notice.id}
                    className='glass glass-frost pointer-events-auto flex max-w-full items-center gap-3 rounded-full p-2 text-espresso animate-in fade-in slide-in-from-bottom-4 duration-500'
                >
                    <span className='flex size-9 shrink-0 items-center justify-center rounded-full bg-espresso text-champagne'>
                        <Check className='size-4' strokeWidth={1.75} />
                    </span>

                    <p className='min-w-0 truncate text-sm'>
                        <span
                            data-mdlfy-cms={notice.cmsId ? `products:${notice.cmsId}:name` : undefined}
                            className='font-medium'
                        >
                            {notice.name}
                        </span>
                        {' '}is in your bag
                    </p>

                    <button
                        type='button'
                        onClick={() => openBag('bag')}
                        className='h-9 shrink-0 rounded-full bg-white/70 px-4 text-[0.68rem] uppercase tracking-[0.18em] ring-1 ring-espresso/10 transition-colors hover:bg-white focus-visible:outline-2 focus-visible:outline-gold-deep'
                    >
                        View bag
                    </button>

                    <button
                        type='button'
                        onClick={dismissNotice}
                        aria-label="Dismiss"
                        className='flex size-9 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-white/70 focus-visible:outline-2 focus-visible:outline-gold-deep'
                    >
                        <X className='size-4' strokeWidth={1.5} />
                    </button>
                </div>
            )}
        </div>
    )
}
